import { toast } from 'react-toastify';

import { Warning, WarningProps } from '../Warning';

export interface FeedbackMessageProps {
  type: WarningProps['variant'];
  description?: string;
  title?: string;
}

function FeedbackMessageSwitch({
  type,
  description,
  title,
}: FeedbackMessageProps) {
  let defaultTitle: string | undefined = title;

  switch (type) {
    case 'success':
      defaultTitle = defaultTitle || 'Gelukt!';
      break;
    case 'info':
      defaultTitle = defaultTitle || 'Opmerking';
      break;
    case 'error':
    default:
      defaultTitle =
        defaultTitle || 'Er ging iets mis, probeer het later nog eens';
      break;
  }

  return (
    <Warning variant={type} size="regular">
      <Warning.Title>{defaultTitle}</Warning.Title>
      {description && <Warning.Description>{description}</Warning.Description>}
    </Warning>
  );
}

export function FeedbackMessage(props: FeedbackMessageProps) {
  toast(FeedbackMessageSwitch(props), {
    autoClose: false,
    hideProgressBar: true,
    closeButton: false,
    closeOnClick: true,
    style: {
      padding: '0',
      background: 'transparent',
    },
  });
}
